import React, { useState, useEffect } from 'react';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import SummaryApi from '../common';
import uploadImage from '../helpers/uploadImage';



const AdminEditProfile = () => {
  const user = useSelector((state) => state?.user?.user);

  const [profilePic, setProfilePic] = useState(user?.profilePic || '');
  const [editableUser, setEditableUser] = useState({
    name: user?.name || '',
    shippingAddress: user?.shippingAddress || '',
    mobileNumber: user?.mobileNumber || '',
  });
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    const fetchUserDetails = async () => {
      try {
        setLoading(true);
        const response = await fetch(SummaryApi.current_user.url, {
          method: SummaryApi.current_user.method,
          credentials: 'include',
          headers: {
            'content-type': 'application/json',
          },
        });
        const responseData = await response.json();
        if (responseData.success) {
          setEditableUser({
            name: responseData.data.name,
            shippingAddress: responseData.data.shippingAddress,
            mobileNumber: responseData.data.mobileNumber,
          });
          setProfilePic(responseData.data.profilePic || '');
        } else {
          toast.error(responseData.message || 'Failed to fetch user details');
        }
      } catch (error) {
      } finally {
        setLoading(false);
      }
    };

    fetchUserDetails();
  }, []);

  const handleChange = (e) => {
    setEditableUser({
      ...editableUser,
      [e.target.name]: e.target.value,
    });
  };

  const handleUploadPic = async (e) => {
    const file = e.target.files[0];
    if (file) {
      const uploadImageCloudinary = await uploadImage(file);
      setProfilePic(uploadImageCloudinary.url);
    }
  };

  const handleRemovePic = () => {
    setProfilePic('');
  };

  const handleSave = async () => {
    try {
      setLoading(true);
      const response = await fetch(SummaryApi.editProfile.url, {
        method: SummaryApi.editProfile.method,
        credentials: 'include',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          userId: user?._id,
          name: editableUser.name,
          shippingAddress: editableUser.shippingAddress,
          mobileNumber: editableUser.mobileNumber,
          profilePic: profilePic || null, // Send null if profilePic is empty
        }),
      });
      const result = await response.json();
  
      if (result.success) {
        toast.success('تم تحديث الملف الشخصى بنجاح');
        window.location.reload(); // Optionally reload the page or update state here
      } else {
        toast.error(result.message || 'فشل تحديث الملف الشخصى');
      }
    } catch (error) {
      toast.error('An error occurred while updating the profile');
    } finally {
      setLoading(false);
    }
  };

  const hasChanges = profilePic !== user?.profilePic || editableUser.name !== user?.name || editableUser.shippingAddress !== user?.shippingAddress || editableUser.mobileNumber !== user?.mobileNumber;

  return (
    <div className="min-h-[calc(100vh-120px)] md:flex">
      

      <main className="w-full h-full p-2">
        <div className="container max-w-xl mx-auto p-5" style={{ marginLeft: '20px' }}>
          <h2 className="text-2xl font-bold mb-5">تعديل ملف المشرف</h2>

          {loading ? (
            <div className="h-32 bg-slate-200 animate-pulse"></div>
          ) : (
            <div className="space-y-4">
              <div className="flex items-center">
                <div className="w-20 h-20 rounded-full overflow-hidden mr-4">
                  <img src={profilePic || user?.profilePic || 'placeholder.png'} alt="Profile" className="w-full h-full object-cover" />
                </div>
                <input type="file" accept="image/*" onChange={handleUploadPic} className="hidden" id="profilePicInput" />
                <label htmlFor="profilePicInput" className="cursor-pointer bg-gray-300 p-2">
                تحميل صورة جديدة
                </label>
                {profilePic && (
                  <button
                    onClick={handleRemovePic}
                    className="ml-4 bg-red-500 hover:bg-red-700 text-white p-2"
                  >
                    ازالة الصورة الحالية
                  </button>
                )}
              </div>
              <div>
                <div className=" justify-between items-center">
                  <h3 className="font-semibold text-right"> عنوان المخزن</h3>
                </div>
                <input
                  type="text"
                  name="shippingAddress"
                  value={editableUser.shippingAddress}
                  onChange={handleChange}
                  className="border rounded p-1 w-full bg-gray-50 text-sm"
                />
              </div>
              <div>
                <div className="text-right">
                  <h3 className="font-semibold">: رقم الهاتف المحمول</h3>
                </div>
                <input
                  type="text"
                  name="mobileNumber"
                  value={editableUser.mobileNumber}
                  onChange={handleChange}
                  className="border rounded p-1 w-full bg-gray-50 text-sm"
                />
              </div>

              <button
                onClick={handleSave}
                className="bg-blue-800 text-white p-2  mt-4"
                disabled={loading || !hasChanges}
              >
                حفظ التعديلات
              </button>
            </div>
          )}
        </div>
      </main>
    </div>
  );
};

export default AdminEditProfile;
